import { useCssHandles } from '../../utils/functions';
import './megaMenuStyles.scss';

const CSS_HANDLES = [
	'menuItem',
	'styledLinkContainer',
	'styledLink',
	'styledLinkContent',
	'styledLinkText',
	'styledLinkIcon',
	'accordionIconContainer',
	'caretIcon',
];
const FirstLevelDesktop = ({ name, blockClass, setSelectedFirstLevel, isSelected, index }) => {
	const { handles } = useCssHandles('vtex-mega-menu-2-x', CSS_HANDLES, blockClass);
	const { handles: handles2 } = useCssHandles(
		'vtex-mega-menu-2-x',
		CSS_HANDLES,
		blockClass,
		isSelected ? 'isOpen' : 'isClosed',
	);

	return (
		<li
			className={`${handles.menuItem} bb b--light-gray bt ${isSelected ? 'bg-black-05' : ''}`}
			onMouseEnter={() => setSelectedFirstLevel(index)}
		>
			<div className={`${handles.styledLinkContainer} pv3 mh5`}>
				<a className={`${handles.styledLink} no-underline c-on-base w-100 pa0 t-body pointer`}>
					<div className={`${handles.styledLinkContainer} flex justify-between`}>
						<div className={`${handles.styledLinkText} flex justify-between items-center nowrap`}>
							<span className={`${handles.styledLinkIcon} flex items-center mr3`} data-testid="icon-left">
								<svg
									fill="none"
									width="16"
									height="16"
									viewBox="0 0 16 16"
									className=" "
									xmlns="http://www.w3.org/2000/svg"
								>
									<use href="#bnd-logo"></use>
								</svg>
							</span>
							{name}
						</div>
						<div className={`${handles2.accordionIconContainer} ml1 c-muted-3`}>
							<svg
								fill="none"
								width="16"
								height="16"
								viewBox="0 0 16 16"
								className={`${handles.caretIcon}`}
								xmlns="http://www.w3.org/2000/svg"
							>
								<use href="#nav-caret--right"></use>
							</svg>
						</div>
					</div>
				</a>
			</div>
		</li>
	);
};

export default FirstLevelDesktop;
